export function updateGUI(bone) {
	const prop = "rotate"
	const vs = ["x", "y", "z"]
	// const vsq = ["x", "y", "z", "w"]

	for (let i = 0; i < vs.length; i++) {
		const v = vs[i]
		const propName = `${bone.name.toLowerCase()}_${prop}_${v}`
		const propValue = bone[prop][v]

		document.getElementById(propName).value = propValue
	}
}


export function radToDeg(radians) {
	return radians * (180 / Math.PI);
}

export function degToRad(degrees) {
	return degrees * (Math.PI / 180);
}

export function throttle(callback, limit, ...args) {
	var wait = false;                  // Initially, we're not waiting
	return function () {               // We return a throttled function
		if (!wait) {                   // If we're not waiting
			callback.call(args);           // Execute users function
			wait = true;               // Prevent future invocations
			setTimeout(function () {   // After a period of time
				wait = false;          // And allow future invocations
			}, limit);
		}
	}
}

export function getRandomColor() {
	var letters = '0123456789ABCDEF';
	var color = '#';
	for (var i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * 16)];
	}
	return color;
}



export function uuidv4() {
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	);
}


/**
 * Merge 2 coords together
 * @param x
 * @param y
 * @returns {{x: *, y: *, z: *}}
 */
export function merge(x, y) {
	return {
		x: x.x + y.x,
		y: x.y + y.y,
		z: x.z + y.z
	}
}



export function positionChanged(p1, p2) {
	// console.log("_positionChanged", p1, p2)
	if (p1 === null || p2 === null)
		return true;

	const rotChange = p2.rotation.x !== p1.rotation.x || p2.rotation.y !== p1.rotation.y || p2.rotation.z !== p1.rotation.z;
	const posChange = p2.position.x !== p1.position.x || p2.position.y !== p1.position.y || p2.position.z !== p1.position.z;

	return rotChange || posChange;
}

export function debounce(func, timeout = 5) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, timeout);
	};
}